// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f5754885","455":"defe5252","977":"1671433f"}[chunkId] + ".chunk.js";
};